import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

export default class Footer {
  constructor(element) {
    this.element = element;
    this.main = document.querySelector('.js-main');
    this.footerHeight = document.querySelector('.js-footer').offsetHeight;

    this.init();
  }

  init() {
    let mm = gsap.matchMedia();

    mm.add('(min-width: 1200px)', () => {
      ScrollTrigger.create({
        trigger: this.main,
        start: `bottom+=${this.footerHeight - 16} bottom`,
        onEnter: () => {
          gsap
            .timeline()
            .to(this.main, {
              ease: 'power1.out',
              duration: 0.3,
              scale: 0.935,
            })
            .to(
              this.element,
              {
                ease: 'power1.out',
                duration: 0.3,
                opacity: 1,
              },
              0.3
            );
        },
        onLeaveBack: () => {
          gsap
            .timeline()
            .to(this.main, {
              ease: 'power1.in',
              duration: 0.3,
              scale: 1,
            })
            .to(
              this.element,
              {
                ease: 'power1.in',
                duration: 0.3,
                opacity: 0,
              },
              '<'
            );
        },
      });
    });
  }
}
